import React, { FunctionComponent, ReactNode } from "react";
import { Card, CardHeader, Typography, CardProps } from "@mui/material";

import styled from "@emotion/styled";
import { colors } from "../themes/colors";

export const StyledOrderCard: React.ComponentType<CardProps> = styled(Card)`
  border: 1px solid ${colors.BORDER_GREY};
  padding: 1rem;
`;

export const StyledOrderCardHeader: FunctionComponent<{
  children: ReactNode;
}> = ({ children }) => (
  <CardHeader
    sx={{
      borderBottom: `1px solid ${colors.BORDER_GREY}`,
    }}
    title={
      <Typography
        variant="h3"
        sx={{
          m: 0,
        }}
      >
        {children}
      </Typography>
    }
  />
);
